import {
  type PostPrayerStreamErrorResponseDto,
  type PostPrayerStreamErrorResponseDtoStatus,
  PostPrayerStreamSuccessResponseDtoStatus,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type RegisterPrayerStreamUserResponseStatus =
  | PostPrayerStreamErrorResponseDtoStatus
  | PostPrayerStreamSuccessResponseDtoStatus;

export type RegisterPrayerStreamUserState = {
  pending: boolean;
  status: RegisterPrayerStreamUserResponseStatus | null;
};

const initialState: RegisterPrayerStreamUserState = {
  pending: false,
  status: null,
};

export const registerPrayerStreamUserSlice = createSlice({
  initialState,
  name: 'registerPrayerStreamUser',
  reducers: {
    registerPrayerStreamUserFailed: (
      state,
      action: PayloadAction<PostPrayerStreamErrorResponseDto>,
    ) => {
      state.pending = false;
      state.status = action.payload.status;
    },
    registerPrayerStreamUserRequested: () => {
      /* handled by saga */
    },
    registerPrayerStreamUserReset: () => {
      return initialState;
    },
    registerPrayerStreamUserStarted: (state) => {
      state.pending = true;
    },
    registerPrayerStreamUserSucceeded: (state) => {
      state.pending = false;
      state.status = PostPrayerStreamSuccessResponseDtoStatus.SUCCESS;
    },
  },
});
